import { createFileRoute } from '@tanstack/react-router';
import { FavoritesPage } from '@/app/aulas/FavoritesPage';

export const Route = createFileRoute('/_app/cursos/_painel/favoritos')({
  component: FavoritesPage,
});
